import { render, staticRenderFns } from "./ItemsChip.vue?vue&type=template&id=7a1e4bdd&scoped=true"
import script from "./ItemsChip.vue?vue&type=script&lang=js"
export * from "./ItemsChip.vue?vue&type=script&lang=js"
import style0 from "./ItemsChip.vue?vue&type=style&index=0&id=7a1e4bdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1e4bdd",
  null
  
)

export default component.exports